import config from "../config";

const validateEmail = (email) => {
    const outcome = String(email).toLowerCase().match(config.regex.email);
    return Boolean(outcome);
};

export { validateEmail };
